import { gql } from '@apollo/client';
import { PROGRAMME } from '../fragments';

export const ALL_FUNDER_PROGRAMMES = gql`
  query AllFunderProgrammes($input: FilterArgs) {
    programmes: funderProgrammes(input: $input) {
      ...programme
      reportersCount
      childProgrammeCount
      geographies {
        id
        name
      }
      theoryOfChangeFile {
        id
        name
        url
      }
    }
  }
  ${PROGRAMME}
`;
